import React, { useRef } from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

// The pages keep dates as 'YYYY-MM-DD' strings; the calendar works with local Date objects
const toDate = (day) => {
    if (!day) return null
    const [y, m, d] = day.split('-').map(Number)
    return new Date(y, m - 1, d)
}
const toDay = (date) => {
    if (!date) return ''
    const pad = (n) => String(n).padStart(2, '0')
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}

const PRESETS = [
    { label: 'Last 30 days', range: (now) => [new Date(now.getFullYear(), now.getMonth(), now.getDate() - 29), now] },
    { label: 'This month', range: (now) => [new Date(now.getFullYear(), now.getMonth(), 1), now] },
    { label: 'Last month', range: (now) => [new Date(now.getFullYear(), now.getMonth() - 1, 1), new Date(now.getFullYear(), now.getMonth(), 0)] },
    { label: 'This year', range: (now) => [new Date(now.getFullYear(), 0, 1), now] },
    { label: 'Last year', range: (now) => [new Date(now.getFullYear() - 1, 0, 1), new Date(now.getFullYear() - 1, 11, 31)] },
]

// One field that picks a from/to range: click a start day, then an end day, or use a shortcut
const DateRange = ({ from, to, onChange, label = 'Date Range' }) => {
    const picker = useRef(null)

    const applyPreset = (preset) => {
        const [start, end] = preset.range(new Date())
        onChange(toDay(start), toDay(end))
        picker.current?.setOpen(false)
    }

    return (
        <div className="form-group DateRange">
            <label>{label}</label>
            <DatePicker
                ref={picker}
                selectsRange
                startDate={toDate(from)}
                endDate={toDate(to)}
                onChange={([start, end]) => onChange(toDay(start), toDay(end))}
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                dateFormat="dd MMM yyyy"
                placeholderText="All dates"
                className="form-control"
                isClearable
                todayButton="Today"
            >
                <div className="DatePresets">
                    {PRESETS.map(preset => (
                        <button type="button" key={preset.label} onClick={() => applyPreset(preset)}>{preset.label}</button>
                    ))}
                </div>
            </DatePicker>
        </div>
    )
}

export default DateRange
